import { ReactElement } from 'react';

import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { Button, ButtonColorVariant, ButtonVariant } from '@dreryk/react-components';

import { systemActivityTranslationKeys } from '../../../translations';
import { isConfidentialResourceAccessRequestPending } from '../../confidentialResourceAccessRequest.utils';
import { isConfidentialResourceAccessRequestSingle } from '../ResourceTypeCell.utils';

import { ReviewRequestModalOpener } from './ConfidentialResourceAccessRequestReview/ReviewRequestModal.opener';
import { RevokeAccessModalOpener } from './RevokeAccessModal/RevokeAccessModal.opener';

type OptionsCellProps = {
   request: ConfidentialResourceAccessRequest;
};

export const OptionsCell = (props: OptionsCellProps): ReactElement | null => {
   const { request } = props;

   if (
      request.resourceType !== 'PATIENT_MEDICAL_DOCUMENTATION_GENERATION' &&
      isConfidentialResourceAccessRequestPending(request)
   ) {
      return (
         <ReviewRequestModalOpener request={request}>
            {({ openModal }) => (
               <Button
                  testId={'review'}
                  label={systemActivityTranslationKeys.review}
                  variant={ButtonVariant.SECONDARY}
                  compact
                  onClick={openModal}
               />
            )}
         </ReviewRequestModalOpener>
      );
   }

   if (request.revocable && isConfidentialResourceAccessRequestSingle(request)) {
      return (
         <RevokeAccessModalOpener request={request}>
            {({ openModal }) => (
               <Button
                  testId={'revokeAccess'}
                  label={systemActivityTranslationKeys.revokeAccess}
                  variant={ButtonVariant.SECONDARY}
                  colorVariant={ButtonColorVariant.ERROR}
                  compact
                  onClick={openModal}
               />
            )}
         </RevokeAccessModalOpener>
      );
   }

   return null;
};
